// @owners { team: patients }
import { type ApplePayActions, FETCH_APPLE_PAY_SUPPORT_SUCCEEDED } from '~shared/actions/ui/applePay';

export type StateUiApplePay = {
  isApplePaySupported: boolean | null;
};

export const initialState: StateUiApplePay = {
  isApplePaySupported: null,
};

const applePay = (state: StateUiApplePay = initialState, action: ApplePayActions): StateUiApplePay => {
  const { type } = action;

  switch (type) {
    case FETCH_APPLE_PAY_SUPPORT_SUCCEEDED: {
      const { payload } = action;
      return { ...state, isApplePaySupported: payload };
    }

    default:
      return state;
  }
};

export default applePay;
